export type EventAction =
  | { type: 'SET_EVENT', event: Julius.Website.EventDetailViewModel }
  | { type: 'SET_IS_FETCHING_EVENT' }
  | { type: 'SET_FETCH_EVENT_FAILED' };

export const setEvent = (event: Julius.Website.EventDetailViewModel): EventAction => ({
  event,
  type: 'SET_EVENT',
});

export const setIsFetching = (): EventAction => ({
  type: 'SET_IS_FETCHING_EVENT',
});

export const setFetchFailed = (): EventAction => ({
  type: 'SET_FETCH_EVENT_FAILED',
});


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/Redux/actions.tsx